import { WhmTypography, whmTheme } from "@securitize/reactjs-whm";
import React, { ReactNode } from "react";
interface InfoCardProps {
  text: ReactNode;
}
export const CardInfo: React.FC<InfoCardProps> = ({ text }) => (
  <WhmTypography
    variant="body2"
    sx={{
      a: {
        textDecoration: "underline !important",
        color: whmTheme.palette.primary.main,
      },
    }}
  >
    {text}
  </WhmTypography>
);
